module.exports = __webpack_public_path__ + "media/sub3-3.6dd2fdaa.mp4";